var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 20,
    height: 15.99,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-714 -371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 20,
    height: 20,
    transform: "translate(714 371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(714 372.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M30.552,1c-.027.129-.045.26-.081.386q-1.963,6.877-3.929,13.753a1.013,1.013,0,0,1-1.194.821.982.982,0,0,1-.765-1.256q.755-2.684,1.525-5.364Q27.315,5.116,28.523.887a1.074,1.074,0,0,1,.769-.854A1.012,1.012,0,0,1,30.552,1",
    transform: "translate(-17.539 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M2.381,15.463c.257.246.457.432.65.624.89.887,1.781,1.773,2.664,2.666a1,1,0,1,1-1.418,1.414Q2.293,18.2.321,16.212a.986.986,0,0,1,.006-1.461q1.965-1.974,3.94-3.939a1,1,0,1,1,1.423,1.411q-1.516,1.529-3.045,3.046a2.514,2.514,0,0,1-.262.195",
    transform: "translate(0 -7.492)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M52.644,15.486c-.182-.172-.332-.308-.474-.45q-1.4-1.4-2.8-2.8a1,1,0,1,1,1.388-1.445c.574.562,1.139,1.135,1.707,1.7q1.1,1.1,2.2,2.2a1.009,1.009,0,0,1,.007,1.564q-1.943,1.947-3.891,3.89a.978.978,0,0,1-1.047.281.966.966,0,0,1-.69-.81,1,1,0,0,1,.333-.9q1.516-1.513,3.03-3.028c.06-.06.129-.113.233-.2",
    transform: "translate(-35.043 -7.491)",
    fill: "#1a1818"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.9710002674e5a56ca7fb94c3f8637154.svg";
export { ForwardRef as ReactComponent };